var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"refTable",staticClass:"v-table",class:{
        'v-table--outlined': _vm.outlined,
        'v-table--scrollable': _vm.scrollable,
        'v-table--fillable': _vm.fillable,
        'v-table--columns': _vm.columns,
    },on:{"scroll":_vm.handleScroll}},[(_vm.loading)?_c('VTableRowEmpty',{attrs:{"borderless":""}},[_c('VSpinner')],1):_vm._t("default",null,{"onLeft":_vm.onLeft,"onTop":_vm.onTop},_vm.params)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }